const AVAILABLE_FOR_OFFER = 'Not Listed: Offer'

export function getAmazonStatus(param: any): any {
    
    let tempStatus: string = '';
    if (param === 'Active' || param === 'active' || param === 'Uploaded' || param === 'uploaded' || param === 'Listed')
        tempStatus = 'success';
    else if (param === 'Inactive' || param === 'inactive' || param.toLowerCase() === 'error')
        tempStatus = 'critical';
    else if (param === 'Incomplete' || param === 'incomplete' || param === 'Partial Listed')
        tempStatus = 'warning';
    else if (param === AVAILABLE_FOR_OFFER)
        tempStatus = 'info'
    else
        tempStatus = ""
    return tempStatus;
}

export const filterCondition = [
    { label: 'equals', value: "1" },
    { label: 'not equals', value: "2", disable_for: ['status', 'type'] },
    { label: 'contains', value: "3", disable_for: ['quantity', 'status', 'type'] },
    { label: 'does not contains', value: "4", disable_for: ['quantity', 'status', 'type'] },
    { label: 'starts with', value: "5", disable_for: ['quantity', 'status', 'type'] },
    { label: 'ends with', value: "6", disable_for: ['quantity', 'status', 'type'] },
    { label: 'greater than or equal to', value: '8', disable_for: ['title', 'tags', 'product_type', 'vendor', 'template_name', 'status', 'sku', 'status', 'type'] },
    { label: 'less than or equal to', value: '9', disable_for: ['title', 'tags', 'product_type', 'vendor', 'template_name', 'status', 'sku', 'status', 'type'] }
];

export const stringOptions = [
    { label: 'Please select', value: "" },
    { value: 'equals', label: "Equals" },
    { value: 'not equals', label: "Not Equals" },
    { value: 'contains', label: "Contains" },
    { value: 'does not contains', label: "Does Not Contains" },
    { value: 'greater than', label: "Greater Than", disabled: true },
    { value: 'less than', label: "Less Than", disabled: true },
    { value: 'greater than or equal to', label: 'Greater Than Equal To', disabled: true },
    { value: 'less than or equal to', label: 'Less Than Equal To', disabled: true },
];

export const numberOptions = [
    { label: 'Please select', value: "" },
    { value: 'equals', label: "Equals" },
    { value: 'not equals', label: "Not Equals" },
    { value: 'contains', label: "Contains", disabled: true },
    { value: 'does not contains', label: "Does Not Contains", disabled: true },
    { value: 'greater than', label: "Greater Than" },
    { value: 'less than', label: "Less Than" },
    { value: 'greater than or equal to', label: 'Greater Than Equal To' },
    { value: 'less than or equal to', label: 'Less Than Equal To' },
];

export const allOptions = [
    { label: 'Please select', value: "" },
    { value: 'equals', label: "Equals" },
    { value: 'not equals', label: "Not Equals" },
    { value: 'contains', label: "Contains", },
    { value: 'does not contains', label: "Does Not Contains", },
    { value: 'greater than', label: "Greater Than" },
    { value: 'less than', label: "Less Than" },
    { value: 'greater than or equal to', label: 'Greater Than Equal To' },
    { value: 'less than or equal to', label: 'Less Than Equal To' },
];

//conditions for attribute condition and choices for attribute value
export const queryOptions = [
    {
        label: "Title", value: "title", conditions: stringOptions,
    },
    {
        label: "Tags", value: "tags", conditions: stringOptions,
    },
    {
        label: "Vendor", value: "brand", choices: [{ label: "hvbdfsc", value: "jbdk" }], conditions: [{ value: 'equals', label: "Equals", disabled: true }]
    },
    {
        label: "Price", value: "price", conditions: numberOptions,
    },
    {
        label: "SKU", value: "sku", conditions: stringOptions,
    },
    {
        label: "Inventory", value: "quantity", conditions: numberOptions,
    },
    {
        label: "Product status", value: "product_status", choices: [], conditions: [{ value: 'equals', label: "Equals", disabled: true }]
    },
    {
        label: "Variant attributes", value: "variant_attributes", choices: [], conditions: [{ value: 'equals', label: "Equals", disabled: true }]
    },
    {
        label: "Type", value: "type", choices: [], conditions: [{ value: 'equals', label: "Equals", disabled: true }]
    },
    {
        label: "Product type", value: "product_type", choices: [], conditions: [{ value: 'equals', label: "Equals", disabled: true }]
    },
];

export const filterConditionsforQuery = [
    { label: "Equals", value: "==" },
    { label: "Not Equals", value: "!=" },
    { label: "Contains", value: "%LIKE%", disable_for: ["price", "quantity"] },
    {
        label: "Does Not Contains",
        value: "!%LIKE%",
        disable_for: ["price", "quantity"],
    },
    {
        label: "Greater Than",
        value: ">",
        disable_for: [
            "title",
            "tags",
            "short_description",
            "vendor",
            "product_type",
            "sku",
        ],
    },
    {
        label: "Less Than",
        value: "<",
        disable_for: [
            "title",
            "tags",
            "short_description",
            "vendor",
            "product_type",
            "sku",
        ],
    },
    {
        label: "Greater Than Equal To",
        value: ">=",
        disable_for: [
            "title",
            "tags",
            "short_description",
            "vendor",
            "product_type",
            "sku",
        ],
    },
    {
        label: "Less Than Equal To",
        value: "<=",
        disable_for: [
            "title",
            "tags",
            "short_description",
            "vendor",
            "product_type",
            "sku",
        ],
    },
];

export const roundOffChoices = [
    { label: 'No round off', value: '0', helpText: 'Same as previous' },
    { label: 'Round off to next higher value', value: 'ceil', helpText: 'E.g. 42.2 will round off to 43.00' },
    { label: 'Round off to previous lower value', value: 'floor', helpText: 'E.g. 42.2 will round off to 42.00' },
    { label: 'End price with 0.49', value: '0.49', helpText: 'E.g. 42, 42.2, etc. will round off to 42.49' },
    { label: 'End price with 0.99', value: '0.99', helpText: 'E.g. 42, 42.2, etc. will round off to 42.99' },
]

export const trendoptionprice = (t: any) => {
    return [
        { label: t("Please Select"), value: "", disabled: true },
        { label: t("Same as Shopify"), value: "default" },
        { label: t("Percentage increase"), value: "percentage_increase" },
        { label: t("Percentage decrease"), value: "percentage_decrease" },
        { label: t("Value increase"), value: "value_increase" },
        { label: t("Value decrease"), value: "value_decrease" },
    ];
}

export const trendOptionBusinessPrice = (t: any) => {
    return [
        { label: t("Please Select"), value: "", disabled: true },
        { label: t("Percentage decrease"), value: "percentage_decrease" },
        { label: t("Value decrease"), value: "value_decrease" },
    ];
}

export function productsStatus() {
    return [
        { label: 'Active', value: 'Active' },
        { label: 'Inactive', value: 'Inactive' },
        { label: 'Incomplete', value: 'Incomplete' },
        // { label: 'Supressed', value: 'Supressed' },
        { label: 'Not Listed', value: 'Disabled' }, // krna hai
        { label: 'Available for Offer', value: 'Available for Offer' },
        { label: 'Uploaded', value: 'Uploaded' }
    ];
}
export function Activity() {
    return [
        { label: 'In Progress', value: 'In Progress' },
        { label: 'Error', value: 'Error' }
    ];
}
export function Type() {
    return [
        { label: 'Simple', value: 'simple' },
        { label: 'Variation', value: 'variation' }
    ];
}


